import { configureStore } from "@reduxjs/toolkit";

import contentReducer from "./features/contentSlice";
import languageReducer from "./features/languageSlice";
import userReducer from "./features/userSlice";
import { contentMiddleware } from "./middleware/contentMiddleware";

const store = configureStore({
  reducer: {
    user: userReducer,
    language: languageReducer,
    content: contentReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(contentMiddleware.middleware),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export default store;
